import axios from 'axios'
import { Point } from '../../Jouly/types/types'

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL + '/api/v1'

export type MomiTelemetryFilter = {
  startDate: string
  stopDate: string
  aggregateWindow: string
}

export async function getMomiTelemetryMeasurement(
  momiUuid: string,
  measurement: string,
  filter: MomiTelemetryFilter
): Promise<Point[]> {
  const range = `start=${filter.startDate},stop=${filter.stopDate}`
  const params = new URLSearchParams({
    uuid: momiUuid,
    range,
    aggregateWindow: filter.aggregateWindow,
  })
  const path = `${BACKEND_URL}/analytics/momi/measurements/${encodeURIComponent(measurement)}`
  return (await axios.get<Point[]>(`${path}?${params.toString()}`)).data
}

export async function getMomiTelemetryLastMeasurement(
  momiUuid: string,
  measurement: string
): Promise<Point[]> {
  const params = new URLSearchParams({
    uuid: momiUuid,
    last: 'true',
  })
  const path = `${BACKEND_URL}/analytics/momi/measurements/${encodeURIComponent(measurement)}`
  return (await axios.get<Point[]>(`${path}?${params.toString()}`)).data
}
